import { useState } from "react";
import { Gift } from "lucide-react";
import api from "../../services/api";

function formatCurrency(v) {
  if (v == null) return "R$ 0,00";
  return "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function DoletasActions({ doletasPerReal, onRefresh }) {
  var _show = useState(false);
  var show = _show[0];
  var setShow = _show[1];
  var _amt = useState("");
  var amt = _amt[0];
  var setAmt = _amt[1];
  var _loading = useState(false);
  var loading = _loading[0];
  var setLoading = _loading[1];

  async function handleRedeem() {
    var val = parseFloat(amt);
    if (isNaN(val) || val <= 0) { alert("Valor invalido"); return; }
    setLoading(true);
    try {
      var res = await api.post("/doletas/redeem", { amount: val });
      alert(res.data.message);
      setShow(false);
      setAmt("");
      if (onRefresh) onRefresh();
    } catch (err) {
      alert("Erro: " + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pt-4">
      <button onClick={function () { setShow(!show); }}
        className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-white/15 hover:bg-white/25 border border-white/20 text-white rounded-xl text-sm font-medium transition-colors"
        data-testid="btn-redeem-doletas">
        <Gift className="w-4 h-4 text-emerald-400" />Resgatar Cashback
      </button>

      {show && (
        <div className="mt-3 bg-white/10 backdrop-blur-sm rounded-xl p-4" data-testid="redeem-form">
          <p className="text-sm font-medium text-white mb-2">Resgate de Cashback</p>
          <p className="text-xs text-white/50 mb-3">Troque suas doletas por desconto em produtos Methos</p>
          <div className="flex gap-2">
            <input type="number" placeholder="Qtd de doletas" value={amt}
              onChange={function (e) { setAmt(e.target.value); }}
              className="flex-1 px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-sm text-white placeholder-white/40"
              data-testid="input-redeem-amount" />
            <button onClick={handleRedeem} disabled={loading}
              className="px-4 py-2 bg-emerald-500 hover:bg-emerald-600 rounded-lg text-sm font-medium text-white disabled:opacity-50"
              data-testid="btn-confirm-redeem">
              {loading ? "..." : "Resgatar"}
            </button>
          </div>
          {amt && parseFloat(amt) > 0 && (
            <p className="text-xs text-emerald-300 mt-2">= {formatCurrency(parseFloat(amt) / (doletasPerReal || 100))}</p>
          )}
        </div>
      )}
    </div>
  );
}
